import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { useLanguage } from '../contexts/LanguageContext';

export const AGB = () => {
  const { t } = useLanguage();
  const L = (key) => t(`legal.agb.${key}`);
  return (
    <div className="min-h-screen flex flex-col bg-ngbc-beige">
      <Header />
      <main className="flex-grow max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-12 mt-20">
        <h1 className="text-4xl font-bold text-ngbc-dark mb-8">{L('title')}</h1>
        
        <div className="bg-ngbc-beige rounded-lg shadow-md p-8 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">{L('s1Title')}</h2>
            <p className="text-ngbc-dark-text">
              {L('s1P1')}
            </p>
            <p className="text-ngbc-dark-text mt-4">
              {L('s1P2')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">{L('s2Title')}</h2>
            <p className="text-ngbc-dark-text">
              {L('s2P1')}
            </p>
            <p className="text-ngbc-dark-text mt-4">
              {L('s2P2')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">§ 3 Teilnahmegebühren und Zahlung</h2>
            <p className="text-ngbc-dark-text">
              Die Teilnahmegebühren richten sich nach der jeweils aktuellen Preisliste, die auf der Website 
              des Veranstalters veröffentlicht ist.
            </p>
            <p className="text-ngbc-dark-text mt-4">
              Die Zahlung ist nach Erhalt der Rechnung innerhalb von 14 Tagen ohne Abzug fällig. Bei verspäteter 
              Zahlung ist der Veranstalter berechtigt, Verzugszinsen in Höhe von 5 Prozentpunkten über dem 
              Basiszinssatz zu berechnen.
            </p>
            <p className="text-ngbc-dark-text mt-4">
              Alle Preise verstehen sich zuzüglich der gesetzlichen Mehrwertsteuer.
            </p>
          </section>

          <section id="widerruf">
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">§ 4 Widerrufsrecht (Verbraucher)</h2>
            <p className="text-ngbc-dark-text">
              Sofern Sie Verbraucher sind, haben Sie ein vierzehntägiges Widerrufsrecht. Die Frist beginnt nach Abschluss des Vertrags. Zur Wahrung der Frist genügt die rechtzeitige Absendung des Widerrufs. Der Widerruf ist zu richten an die im Impressum genannte Kontaktadresse.
            </p>
            <p className="text-ngbc-dark-text mt-4">
              Bei einem wirksamen Widerruf sind die beiderseits empfangenen Leistungen zurückzugewähren. Für die Nutzung der Leistung bis zum Widerruf kann eine angemessene Vergütung verlangt werden.
            </p>
          </section>

          <section>
            <p className="text-ngbc-dark-text">
              Stornierungen müssen schriftlich oder in Textform erfolgen. Bei Stornierung gelten folgende 
              Stornierungsgebühren:
            </p>
            <ul className="list-disc ml-6 mt-4 text-ngbc-dark-text space-y-2">
              <li>Bis 60 Tage vor Veranstaltungsbeginn: 25% der Teilnahmegebühr</li>
              <li>59 bis 30 Tage vor Veranstaltungsbeginn: 50% der Teilnahmegebühr</li>
              <li>29 bis 14 Tage vor Veranstaltungsbeginn: 75% der Teilnahmegebühr</li>
              <li>Ab 13 Tage vor Veranstaltungsbeginn: 100% der Teilnahmegebühr</li>
            </ul>
            <p className="text-ngbc-dark-text mt-4">
              Eine Ersatzperson kann ohne zusätzliche Kosten gestellt werden.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">§ 6 Leistungen des Veranstalters</h2>
            <p className="text-ngbc-dark-text">
              Der Veranstalter verpflichtet sich, die Veranstaltung entsprechend der Ausschreibung durchzuführen. 
              Programmänderungen bleiben vorbehalten, sofern sie den Charakter der Veranstaltung nicht wesentlich 
              verändern.
            </p>
            <p className="text-ngbc-dark-text mt-4">
              Der Veranstalter ist berechtigt, Referenten auszutauschen oder einzelne Programmpunkte zu ändern, 
              wenn dies aus wichtigem Grund erforderlich ist.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">§ 7 Pflichten des Teilnehmers/Ausstellers</h2>
            <p className="text-ngbc-dark-text">
              Der Teilnehmer/Aussteller verpflichtet sich, die Hausordnung der Veranstaltungsstätte sowie die 
              Anweisungen des Veranstalters und seines Personals zu befolgen.
            </p>
            <p className="text-ngbc-dark-text mt-4">
              Aussteller sind für den Auf- und Abbau ihres Standes innerhalb der vorgegebenen Zeiträume 
              selbst verantwortlich. Der Standplatz ist in ordnungsgemäßem Zustand zurückzugeben.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">§ 8 Haftung</h2>
            <p className="text-ngbc-dark-text">
              Der Veranstalter haftet unbeschränkt für Schäden aus der Verletzung des Lebens, des Körpers oder 
              der Gesundheit, die auf einer vorsätzlichen oder fahrlässigen Pflichtverletzung des Veranstalters 
              oder einer vorsätzlichen oder fahrlässigen Pflichtverletzung eines gesetzlichen Vertreters oder 
              Erfüllungsgehilfen des Veranstalters beruhen.
            </p>
            <p className="text-ngbc-dark-text mt-4">
              Für sonstige Schäden haftet der Veranstalter nur bei Vorsatz und grober Fahrlässigkeit. Eine 
              Haftung für mitgebrachte Gegenstände der Teilnehmer/Aussteller ist ausgeschlossen, soweit 
              gesetzlich zulässig.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">§ 9 Ausfall der Veranstaltung</h2>
            <p className="text-ngbc-dark-text">
              Bei Ausfall der Veranstaltung aus Gründen, die der Veranstalter nicht zu vertreten hat 
              (höhere Gewalt, behördliche Anordnungen, etc.), werden bereits gezahlte Teilnahmegebühren 
              zurückerstattet. Weitergehende Ansprüche bestehen nicht.
            </p>
            <p className="text-ngbc-dark-text mt-4">
              Der Veranstalter bemüht sich in einem solchen Fall, einen Ersatztermin anzubieten.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">§ 10 Bild- und Tonaufnahmen</h2>
            <p className="text-ngbc-dark-text">
              Mit der Anmeldung erklärt sich der Teilnehmer damit einverstanden, dass während der Veranstaltung 
              Bild- und Tonaufnahmen erstellt werden können. Diese können für Dokumentations- und Marketingzwecke 
              des Veranstalters verwendet werden.
            </p>
            <p className="text-ngbc-dark-text mt-4">
              Ein Widerspruch kann jederzeit schriftlich oder in Textform gegenüber dem Veranstalter erklärt werden.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">§ 11 Datenschutz</h2>
            <p className="text-ngbc-dark-text">
              Der Veranstalter erhebt und verarbeitet personenbezogene Daten der Teilnehmer ausschließlich zur 
              Durchführung der Veranstaltung. Weitere Informationen zum Datenschutz finden sich in unserer 
              Datenschutzerklärung.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">§ 12 Salvatorische Klausel</h2>
            <p className="text-ngbc-dark-text">
              Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, berührt dies die Wirksamkeit 
              der übrigen Bestimmungen nicht. Anstelle der unwirksamen Bestimmung gilt eine wirksame Regelung 
              als vereinbart, die dem wirtschaftlichen Zweck der unwirksamen Bestimmung am nächsten kommt.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-ngbc-dark mb-4">§ 13 Anwendbares Recht und Gerichtsstand</h2>
            <p className="text-ngbc-dark-text">
              Es gilt ausschließlich das Recht der Bundesrepublik Deutschland unter Ausschluss des 
              UN-Kaufrechts (CISG).
            </p>
            <p className="text-ngbc-dark-text mt-4">
              Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang mit diesem Vertrag ist, 
              soweit gesetzlich zulässig, der Sitz des Veranstalters.
            </p>
          </section>

          <section className="border-t pt-6">
            <p className="text-gray-600 text-sm italic">
              {L('stand')}
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};
